module.exports = __webpack_public_path__ + "img/move.9b3fce6c.svg";